import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBrandsProps, IconRender } from '../types.ts';

const Microsoft = React.forwardRef<SVGSVGElement | null, IconBrandsProps>(function Microsoft({ colored, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path d='M2 2H11V11H2V2Z' fill={colored ? 'transparent' : color} />
        <path d='M13 2H22V11H13V2Z' fill={colored ? 'transparent' : color} />
        <path d='M13 13H22V22H13V13Z' fill={colored ? 'transparent' : color} />
        <path d='M2 13H11V22H2V13Z' fill={colored ? 'transparent' : color} />
        {/* colored */}
        <rect x='2' y='2' width='9' height='9' fill={colored ? '#F25022' : 'transparent'} />
        <rect x='13' y='2' width='9' height='9' fill={colored ? '#7FBA00' : 'transparent'} />
        <rect x='13' y='13' width='9' height='9' fill={colored ? '#FFB900' : 'transparent'} />
        <rect x='2' y='13' width='9' height='9' fill={colored ? '#00A4EF' : 'transparent'} />
      </>
    ),
    [colored],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'microsoft-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Microsoft;
